import React from 'react';
import DetailSectionHeader from './DetailSectionHeader';
import numeral from 'numeral';

interface ImportantDetailsFullProps {
  status: string | undefined,
  time: string | null,
  propertyType: string | undefined,
  price: string | undefined,
  pricePerFoot: number | undefined,
  livingArea: number | undefined,
  lotSizeAcres: number | undefined,
  yearBuilt: Date | undefined,
  county: string | undefined,
  community: string | undefined,
  associationYN: boolean | undefined,
  associationFee: number | undefined,
  associationFeeFrequency: string | undefined,
  listingDate: Date | undefined,
  closePrice: string | undefined,
  closeDate: Date | undefined,
}

const ImportantDetails = ({status, time, propertyType, price, pricePerFoot, livingArea, lotSizeAcres, yearBuilt, county, community, associationYN, associationFee, associationFeeFrequency, listingDate, closeDate, closePrice} : ImportantDetailsFullProps) => {

	return (
		<article className="property-details__section">
			<DetailSectionHeader icon="fa-home" title="Important Details" />
			<div className="property-details__section-info d-flex align-items-start">
				<div className="col-6">
					<ul className="list-unstyled">
						{status && <li><span className="cc-font-weight--normal">Status:</span> {status}</li>}
						{listingDate && <li><span className="cc-font-weight--normal">Date listed:</span> {new Date(listingDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}</li>}
						{closeDate && <li><span className="cc-font-weight--normal">Date closed:</span> {new Date(closeDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}</li>}
						{time && <li><span className="cc-font-weight--normal">Time on Market:</span> {time}</li>}
						{propertyType && <li><span className="cc-font-weight--normal">Property Type:</span> {propertyType}</li>}
						{price && <li><span className="cc-font-weight--normal">List Price:</span> ${price}</li>}
						{(closePrice && closePrice !== '0') ? (
							<li><span className="cc-font-weight--normal">Close Price:</span> ${closePrice}</li>
						) : <></>}
						{(pricePerFoot && pricePerFoot > 0) ? (
							<li><span className="cc-font-weight--normal">Price/Sq. Ft:</span> ${pricePerFoot}</li>
						) : <></>}
					</ul>
				</div>
				<div className="col-6">
					<ul className="list-unstyled">
						{livingArea && livingArea >= 0 && <li><span className="cc-font-weight--normal">Living area:</span> {numeral(livingArea).format()} sq. feet</li>}
						<li><span className="cc-font-weight--normal">Lot Size:</span> { lotSizeAcres && lotSizeAcres >= 0 ? `${lotSizeAcres} acres` : 'None listed' }</li>
						{yearBuilt && <li><span className="cc-font-weight--normal">Year Built:</span> {yearBuilt}</li>}
						{county && <li><span className="cc-font-weight--normal">County:</span> {county}</li>}
						{community && <li><span className="cc-font-weight--normal">Community:</span> {community}</li>}
						{associationYN
							? associationFee
								? <li>
									<span className="cc-font-weight--normal">HOA Dues:</span> ${associationFee}/{associationFeeFrequency}
								</li>
								: <li><span className="cc-font-weight--normal">HOA:</span> Yes</li>
							: <li><span className="cc-font-weight--normal">HOA:</span> No</li>
						}
					</ul>
				</div>
			</div>
		</article>
	);
};


export default ImportantDetails;
